import { ROW_NUMBER_COLUMN } from "../elements/table/TableElement/constants";
import { TableRow } from "../types";

export const getTableRowIndex = (row: TableRow): number =>
  row[ROW_NUMBER_COLUMN.key] as number;
